/**
 * @file plugins/monitor.client.js
 */
import Vue from 'vue';

export default function () {
  Vue.config.errorHandler = (e) => {
    console.warn('err', e);
  };
}
